import { Component, Input, OnInit } from '@angular/core';
import { ActivityEditorBaseComponent } from '../../activity-editor-base/activity-editor-base.component';
import { SignOffActivity, SignOffActivityModel } from 'src/app/models/activities/sign-off-activity';

@Component({
  selector: 'wm-sign-off-activity-editor',
  templateUrl: './sign-off-activity-editor.component.html',
  styleUrls: ['./sign-off-activity-editor.component.css'],
  standalone: false
})
export class SignOffActivityEditorComponent extends ActivityEditorBaseComponent implements OnInit {
  @Input() activity: SignOffActivity;

  constructor() {
    super();
  }

  ngOnInit() {
    this.activity.model = (this.activity.model as SignOffActivityModel);
  }
}
